import React from "react";
import styled from "styled-components";
import {
  Container,
  Section,
  SectionTitle,
  SectionDescription,
} from "../../components/Section";
import {ArrowLeftIcon} from '../../components/Icons';
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";


const CardFigure = styled.figure`
  position: relative;
  cursor: pointer;
  margin:0;

  background: -webkit-linear-gradient(-45deg, #000 0%,#fff 100%);
	background: linear-gradient(-45deg, #000 0%,#fff 100%);
  &.effect-lexi .gatsby-image-wrapper {
    margin: -10px 0 0 -10px;
    max-width: none;
    width: -webkit-calc(100% + 10px);
    width: calc(100% + 10px);
    opacity: 0.9;
    -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
    transition: opacity 0.35s, transform 0.35s;
    -webkit-transform: translate3d(10px,10px,0);
    transform: translate3d(10px,10px,0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
        
  }

  &.effect-lexi figcaption::before,
  &.effect-lexi p {
    -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
    transition: opacity 0.35s, transform 0.35s;
  }

  &.effect-lexi figcaption::before {
    position: absolute;
    right: -100px;
    bottom: -100px;
    width: 200px;
    height: 200px;
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 0 0 900px rgba(255,255,255,0.2);
    content: '';
    opacity: 0;
    -webkit-transform: scale3d(0.5,0.5,1);
    transform: scale3d(0.5,0.5,1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }

  &.effect-lexi:hover .gatsby-image-wrapper {
    opacity: 0.6;
    -webkit-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
  }

  &.effect-lexi h2 {
    text-align: left;
    -webkit-transition: -webkit-transform 0.35s;
    transition: transform 0.35s;
    -webkit-transform: translate3d(5px,5px,0);
    transform: translate3d(5px,5px,0);
  }

  &.effect-lexi p {
    position: absolute;
    right: 0;
    bottom: 0;
    padding:0;
    margin:0;
    opacity: 0;
    -webkit-transform: translate3d(20px,20px,0);
    transform: translate3d(20px,20px,0);
  }

  &.effect-lexi:hover figcaption::before {
    opacity: 1;
    -webkit-transform: scale3d(1,1,1);
    transform: scale3d(1,1,1);
  }

  &.effect-lexi:hover h2,
  &.effect-lexi:hover p {
    opacity: 1;
    -webkit-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
  }

  &.effect-lexi .icon{
    width:40px;
    height:40px;
    border-radius:50%;
    background-color:#fff;
    display:flex;
    align-items:center;
    justify-content:center;
    position: absolute;
    right: 10px;
    bottom: 10px;
    svg{
      height: 12px;
      fill:#EC2C31;
    }
  }
  
`;
export const CategoryName = styled.h2`
  position: absolute;
  z-index:1;
  font-weight: 600;
  margin-bottom: 0;
  color: #373636;  
  top:20px;
  left:20px;  
  font-size: 20px;
  line-height: 26px;
  @media (min-width: 992px) {
    max-width: 100px;
    width: 100%;    
  }
  @media (min-width: 1200px) {
    font-size: 24px;
    line-height: 30px;
  }
`;


const CategoryGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -5px;  
`;
const CategoryGridItem = styled.div`
  position: relative;
  width: 100%;
  padding: 0 5px;
  margin-bottom:15px;
  @media (min-width: 768px) {
    max-width: 50%;
    flex: 0 0 50%;
  }
  @media (min-width: 992px) {
    max-width: 20%;
    flex: 0 0 20%;
  }
  a{
    border-radius: 20px;
    overflow: hidden;
    display: block;
    @media (max-width: 575.98px) {
      max-width: 340px;
      margin: 0 auto;
      width: 100%;
    }
  }
`;

const ProductCategoryListSection = ({ data }) => {
  return (
    <Section
      ept="60px"
      epb="60px"
      xpt="40px"
      xpb="40px"
      pt="30px"
      pb="30px"
      bgColor="#fff"
      bgBefore="#cdd0d6"
      bgBeforeWidth="100%"
      bgBeforeHeight="1px"
      top="0"
    >
      <Container>
        <SectionTitle textAlign="center">{data?.heading}</SectionTitle>
        <SectionDescription textAlign="center">
          {data?.subheading}
        </SectionDescription>
        <CategoryGrid>
          {!!data.categories &&
            data.categories.length > 0 &&
            data.categories.map((category, i) => {
              const url = category.title.split(" ").join("-").toLowerCase();

              return (
                <CategoryGridItem key={i}>
                  <Link to={`/${url}`}>
                    <CardFigure className="category-figure effect-lexi">
                      <GatsbyImage image={category.thumbnail ? category.thumbnail.gatsbyImageData : category.heroImage.gatsbyImageData} alt={category.title} /> 
                      <figcaption className="category-caption">
                        <CategoryName className="category-name">{category.title}</CategoryName>
                        <p className="category-link"><span className="icon"><ArrowLeftIcon /></span></p>
                      </figcaption>                      
                    </CardFigure>
                  </Link>
                </CategoryGridItem>
              );
            })}
        </CategoryGrid>
      </Container>
    </Section>
  );
};

export default ProductCategoryListSection;
